<template>
  <div>
  <section class="section">
    <div class="container">
      <div class="control has-icons-left">
        <div class="select">
          <select>
            <option>GCP</option>
            <option disabled>AWS - Coming soon</option>
            <option disabled>Azure - Coming soon</option>
          </select>
        </div>
        <span class="icon is-left">
          <i class="fas fa-globe"></i>
        </span>
      </div>
    </div>
    <section class="section">
      <div class="pricing-table is-comparative">
        <div class="pricing-plan is-features">
          <div class="plan-header">Features</div>
          <div class="plan-price"><span class="plan-price-amount">&nbsp;</span></div>
          <div class="plan-items">
            <div class="plan-item">Support</div>
            <div class="plan-item">Flow & Schema Registries</div>
            <div class="plan-item">Number of managed nodes</div>
            <div class="plan-item">Total cores</div>
            <div class="plan-item">Total Memory</div>
            <div class="plan-item">Total Storage</div>
            <div class="plan-item">Total Bandwidth</div>
            <div class="plan-item">High Availability</div>
            <div class="plan-item">Custom Domain</div>
            <div class="plan-item">Static IP</div>
          </div>
          <div class="plan-footer">

          </div>
        </div>
        <div class="pricing-plan is-warning"
             v-on:mouseover="change('starter', true)"
             v-bind:class="{ 'is-active': hoverStatus['starter']  }">
          <div class="plan-header">Starter</div>
          <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>{{starter_price}}</span>AUD/month</div>
          <div class="plan-items">
            <div class="plan-item" data-feature="support">Email support</div>
            <div class="plan-item" data-feature="registries"><i class="fas fa-times"></i></div>
            <div class="plan-item" data-feature="number-of-nodes">1</div>
            <div class="plan-item" data-feature="number-of-cores">Up to 16</div>
            <div class="plan-item" data-feature="memory">Up to 108GB</div>
            <div class="plan-item" data-feature="storage">1TB</div>
            <div class="plan-item" data-feature="bandwidth">500 GB</div>
            <div class="plan-item" data-feature="ha"><i class="fas fa-times"></i></div>
            <div class="plan-item" data-feature="custom-domain"><i class="fas fa-times"></i></div>
            <div class="plan-item" data-feature="static-ip"><i class="fas fa-check"></i></div>
          </div>
          <div class="plan-footer">
            <button class="button is-fullwidth" disabled="disabled">Choose</button>
          </div>
        </div>

        <div class="pricing-plan is-primary"
        v-on:mouseover="change('growing', true)"
        v-bind:class="{ 'is-active': hoverStatus['growing']  }">
          <div class="plan-header">Growing Team</div>
          <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>{{growing_price}}</span>AUD/month</div>
          <div class="plan-items">
            <div class="plan-item" data-feature="support">Phone support</div>
            <div class="plan-item" data-feature="registries"><i class="fas fa-check"></i></div>
            <div class="plan-item" data-feature="number-of-nodes">3</div>
            <div class="plan-item" data-feature="number-of-cores">Up to 48</div>
            <div class="plan-item" data-feature="memory">Up to 324GB</div>
            <div class="plan-item" data-feature="storage">3TB</div>
            <div class="plan-item" data-feature="bandwidth">1TB</div>
            <div class="plan-item" data-feature="ha"><i class="fas fa-check"></i></div>
            <div class="plan-item" data-feature="custom-domain"><i class="fas fa-check"></i></div>
            <div class="plan-item" data-feature="static-ip"><i class="fas fa-check"></i></div>
          </div>
          <div class="plan-footer">
            <button class="button is-fullwidth" disabled="disabled">Choose</button>
          </div>
        </div>

        <div class="pricing-plan is-danger"
        v-on:mouseover="change('enterprise', true)"
        v-bind:class="{ 'is-active': hoverStatus['enterprise']  }">
          <div class="plan-header">Enterprise</div>
          <div class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">Ask for a quote!</span></span></div>
          <div class="plan-items">
            <div class="plan-item" data-feature="support"><i class="fas fa-check"></i></div>
            <div class="plan-item" data-feature="registries"><i class="fas fa-check"></i></div>
            <div class="plan-item" data-feature="number-of-nodes"><i class="fas fa-check"></i></div>
            <div class="plan-item" data-feature="number-of-cores"><i class="fas fa-check"></i></div>
            <div class="plan-item" data-feature="memory"><i class="fas fa-check"></i></div>
            <div class="plan-item" data-feature="storage"><i class="fas fa-check"></i></div>
            <div class="plan-item" data-feature="bandwidth"><i class="fas fa-check"></i></div>
            <div class="plan-item" data-feature="ha"><i class="fas fa-check"></i></div>
            <div class="plan-item" data-feature="custom-domain"><i class="fas fa-check"></i></div>
            <div class="plan-item" data-feature="static-ip"><i class="fas fa-check"></i></div>
          </div>
          <div class="plan-footer">
            <button class="button is-fullwidth" disabled="disabled">Contact us</button>
          </div>
        </div>
      </div>
    </section>

  </section>
</div>
</template>
<script>
export default {
  name: 'Pricing',
  data () {
    return {
      hoverStatus: {},
      growing_price: 3600,
      starter_price: 1500
    }
  },
  methods: {
    change (k, v) {
      // First reset the status
      Object.keys(this.hoverStatus).forEach(key => {
        this.$set(this.hoverStatus, key, false)
      })
      // Then set the value we are hovering
      this.$set(this.hoverStatus, k, v)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Pricing.vue